// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5012e51","389":"ccfb1828","732":"a0f3b948","857":"c958bf3c","977":"6bf48248"}[chunkId] + ".chunk.js";
};